import React from 'react';
import { Components } from 'index';

export const LoadComponent = (id, props = {}, alt = null) => {
    if(Components[id]) {
        const Modul = Components[id];
        return (<Modul { ...props }/>);
    } else if(alt) {
        const Alt = alt;
        return (<Alt { ...props }/>);
    } else {
        //console.log("NO COMPONENT " + id);
        return "";
    }
}

export const GetComponent = (id, alt = null) => {
    if(Components[id]) {
        return Components[id];
    } else {
        return alt;
    }
}
